export { PORTFOLIO_ITEMS } from "./portfolio";

export const CONTACT = {
  email: "info@bymela.com",
  phone: "+39 339 441 0794",
  phoneDisplay: "+39 339 441 0794",
  linkedin: "https://www.linkedin.com/in/emanuela-serena-68215b284/",
};

export const CONTENT = {
  it: {
    nav: [
      { id: "chi-sono", label: "Chi Sono" },
      { id: "progetti", label: "Progetti" },
      { id: "collaborazioni", label: "Rassegna Stampa" },
      { id: "servizi", label: "Servizi" },
      { id: "contatti", label: "Contatti" },
    ],
    hero: {
      overline: "Architettura · Design · Gioielli · Accessori",
      nameA: "Emanuela",
      nameB: "Serena",
      role: "Architecture, Jewelry & Accessory Design",
      sloganPrimary: "L'architettura incontra l'arte del vetro e il design di gioielli",
      sloganSecondary: "Where architectural vision meets Murano glass artistry and fine accessory design.",
      ctaWorks: "Esplora i Progetti",
      ctaContact: "Contatti",
      scrollHint: "Scorri",
    },
    marquee: [
      "Vetro di Murano",
      "Modellazione Orafa",
      "BAB — Build A Bag",
      "Design Architettonico",
      "Luxury Accessories",
      "Made in Venice",
    ],
    about: {
      overline: "01 — Biografia",
      title: "Chi Sono & Filosofia",
      chapters: [
        {
          num: "I",
          heading: "La Visione Architettonica",
          body: "Laureata in Architettura all'IUAV di Venezia con specializzazione come Modellista Orafa, Emanuela Serena coniuga la rigorosa visione strutturale dell'architetto con la sensibilità artigianale dell'alta gioielleria. Dal 2007, anno di fondazione del suo marchio Mela, progetta bijoux, gioielli e accessori moda caratterizzati da un forte valore concettuale e da un'attenta ricerca sui materiali.",
        },
        {
          num: "II",
          heading: "Il Percorso e le Partnership",
          body: "Il suo percorso è segnato da importanti partnership con storiche ditte di settore come SM3000 (per il marchio MurrinaMurano), Gli Ori di Venezia, Antonio Vaccari e Caleidos, per la quale ha ideato e ceduto in licenza il celebre progetto di borse modularizzabili BAB (Build A Bag). Le sue creazioni sono state selezionate da prestigiosi bookshop museali e retail internazionali, tra cui il Gran Teatro La Fenice di Venezia, Palazzo Strozzi a Firenze, il Mart di Rovereto e Coin. Ogni collezione nasce da un'accurata analisi del target e da un dialogo profondo tra forma, colore e la luce.",
        },
      ],
      quoteNum: "III",
      quoteHeading: "La Materia Nobilitata",
      quote: "Ogni materiale, attraverso la fantasia, può essere nobilitato a diventare gioiello",
      imageCaptionA: "Schizzi — BAB · Build A Bag",
      imageCaptionB: "Moodboard — Feel 925",
      sketchesTitle: "Bozzetti & Ricerca",
    },
    portfolio: {
      overline: "02 — Opere Selezionate",
      title: "Progetti Portfolio",
      intro:
        "Una selezione di progetti tra vetro di Murano, pelletteria modulare e gioielleria: dall'architettura del concept al prodotto finito.",
      filters: { murano: "MurrinaMurano Donna", uomo: "MurrinaMurano Uomo", feel: "Feel 925", gliori: "Gli Ori di Venezia", vaccari: "Antonio Vaccari", bags: "BAB — Pelletteria", mela: "Mela" },
      categories: {
        murano: "MurrinaMurano Donna",
        bags: "Pelletteria e Borse — BAB",
        mela: "Mela — Bijoux & Accessori",
        uomo: "MurrinaMurano Uomo",
        feel: "Feel 925 — MurrinaMurano",
        vaccari: "Antonio Vaccari",
        gliori: "Gli Ori di Venezia",
      },
      modal: { client: "Cliente", year: "Anno", category: "Categoria", materials: "Materiali", close: "Chiudi" },
    },
    collab: {
      overline: "03 — Percorso",
      title: "Rassegna Stampa",
      press: ["Vogue Accessory", "Tu Style", "Ornamenta", "Cosmopolitan", "Glamour", "Confidenze", "Preziosa Magazine"],
    },
    services: {
      overline: "04 — Expertise",
      title: "Competenze & Servizi",
      items: [
        { title: "Identificazione del Concept", desc: "Definizione dell'idea guida di ogni collezione, dall'analisi del target alla visione creativa." },
        { title: "Moodboard di Collezione", desc: "Creazione di una mood board dedicata per ogni collezione: colori, materiali e atmosfere." },
        { title: "Processo Creativo Condiviso", desc: "Condivisione del processo creativo e realizzativo delle collezioni, a partire dalle prime bozze." },
        { title: "Prototipazione & Campionario", desc: "Prototipazione dei pezzi e presentazione del campionario completo, pronto per la produzione." },
        { title: "Schede Tecniche", desc: "Preparazione delle schede tecniche dettagliate per la produzione orafa e degli accessori." },
        { title: "Presentazione delle Collezioni", desc: "Presentazione delle collezioni a buyer, stampa e partner del settore." },
        { title: "Supervisione Shooting & Fiere", desc: "Supervisione delle fasi di presentazione, shooting, backstage e fiere di settore." },
      ],
    },
    contact: {
      overline: "05 — Contatti",
      titleA: "Parliamo del",
      titleB: "prossimo progetto.",
      intro:
        "Disponibile per collaborazioni con brand di moda, ditte di gioielleria, case di design e aziende del settore accessori.",
      emailLabel: "Scrivimi",
      phoneLabel: "Telefono",
      linkedinLabel: "Profilo LinkedIn",
    },
    footer: "Architettura · Gioiello · Accessorio — Venezia",
  },
  en: {
    nav: [
      { id: "chi-sono", label: "About" },
      { id: "progetti", label: "Works" },
      { id: "collaborazioni", label: "Press" },
      { id: "servizi", label: "Services" },
      { id: "contatti", label: "Contact" },
    ],
    hero: {
      overline: "Architecture · Design · Jewelry · Accessories",
      nameA: "Emanuela",
      nameB: "Serena",
      role: "Architecture, Jewelry & Accessory Design",
      sloganPrimary: "Where architectural vision meets Murano glass artistry and fine accessory design.",
      sloganSecondary: "L'architettura incontra l'arte del vetro e il design di gioielli",
      ctaWorks: "Explore the Works",
      ctaContact: "Contact",
      scrollHint: "Scroll",
    },
    marquee: [
      "Murano Glass",
      "Goldsmith Modelling",
      "BAB — Build A Bag",
      "Architectural Design",
      "Luxury Accessories",
      "Made in Venice",
    ],
    about: {
      overline: "01 — Biography",
      title: "About & Philosophy",
      chapters: [
        {
          num: "I",
          heading: "The Architectural Vision",
          body: "Holding a degree in Architecture from IUAV University of Venice and trained as a Master Goldsmith Model Maker, Emanuela Serena seamlessly blends architectural structural vision with the refined artistry of fine jewelry making. Since launching her brand Mela in 2007, she has been designing jewelry and fashion accessories defined by strong conceptual research and material exploration.",
        },
        {
          num: "II",
          heading: "The Journey & Partnerships",
          body: "Her career features collaborations with renowned industry leaders including SM3000 (for the MurrinaMurano brand), Gli Ori di Venezia, Antonio Vaccari, and Caleidos—with whom she developed and licensed the innovative BAB (Build A Bag) collection. Her designs have been showcased at major trade fairs like Pitti Immagine and Macef Milano, as well as prestigious museum bookshops such as Palazzo Strozzi in Florence, Gran Teatro La Fenice in Venice, and MART in Rovereto.",
        },
      ],
      quoteNum: "III",
      quoteHeading: "Ennobled Matter",
      quote: "Through imagination, any material can be elevated into a piece of jewelry.",
      imageCaptionA: "Sketches — BAB · Build A Bag",
      imageCaptionB: "Moodboard — Feel 925",
      sketchesTitle: "Sketches & Research",
    },
    portfolio: {
      overline: "02 — Selected Works",
      title: "Portfolio Projects",
      intro:
        "A selection of projects across Murano glass, modular leather goods and fine bijoux: from concept architecture to the finished product.",
      filters: { murano: "MurrinaMurano Women", uomo: "MurrinaMurano Men", feel: "Feel 925", gliori: "Gli Ori di Venezia", vaccari: "Antonio Vaccari", bags: "BAB — Leather Goods", mela: "Mela" },
      categories: {
        murano: "MurrinaMurano Women",
        bags: "Leather Goods & Bags — BAB",
        mela: "Mela — Bijoux & Accessories",
        uomo: "MurrinaMurano Men",
        feel: "Feel 925 — MurrinaMurano",
        vaccari: "Antonio Vaccari",
        gliori: "Gli Ori di Venezia",
      },
      modal: { client: "Client", year: "Year", category: "Category", materials: "Materials", close: "Close" },
    },
    collab: {
      overline: "03 — Track Record",
      title: "Press",
      press: ["Vogue Accessory", "Tu Style", "Ornamenta", "Cosmopolitan", "Glamour", "Confidenze", "Preziosa Magazine"],
    },
    services: {
      overline: "04 — Expertise",
      title: "Services & Expertise",
      items: [
        { title: "Concept Identification", desc: "Defining the guiding idea of each collection, from target analysis to creative vision." },
        { title: "Collection Moodboards", desc: "A dedicated mood board for every collection: colours, materials and atmospheres." },
        { title: "Shared Creative Process", desc: "Sharing the creative and production process of each collection, starting from the first sketches." },
        { title: "Prototyping & Sample Set", desc: "Prototyping the pieces and presenting the complete sample set, ready for production." },
        { title: "Technical Sheets", desc: "Preparing detailed technical sheets for jewelry and accessory manufacturing." },
        { title: "Collection Presentations", desc: "Presenting collections to buyers, press and industry partners." },
        { title: "Shooting & Trade Fair Supervision", desc: "Supervising presentations, photo shoots, backstage and industry trade fairs." },
      ],
    },
    contact: {
      overline: "05 — Contact",
      titleA: "Let's discuss your",
      titleB: "next project.",
      intro:
        "Available for collaborations with fashion brands, jewelry houses, design studios and accessory companies.",
      emailLabel: "Write to me",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn Profile",
    },
    footer: "Architecture · Jewelry · Accessory — Venice",
  },
};
